import { render, staticRenderFns } from "./GamificationAward.vue?vue&type=template&id=ef82e526&scoped=true"
import script from "./GamificationAward.vue?vue&type=script&lang=js"
export * from "./GamificationAward.vue?vue&type=script&lang=js"
import style0 from "./GamificationAward.vue?vue&type=style&index=0&id=ef82e526&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef82e526",
  null
  
)

export default component.exports